const themeColors = {
  //* Use theme instead of brand (brand is too dark sometimes)
  brand: {
    50: '#fff5d3',
    100: '#ffe6a5',
    200: '#ffd36d',
    300: '#ffb432',
    400: '#ff9b0a',
    500: '#f77f00',
    600: '#cc6002',
    700: '#a14a0b',
    800: '#823e0c',
    900: '#461d04',
  },
  theme: {
    50: '#fff5d3',
    100: '#ffe6a5',
    200: '#ffd36d',
    300: '#ffb432',
    400: '#ff9b0a',
    500: '#f77f00',
    600: '#cc6002',
    700: '#a14a0b',
    800: '#823e0c',
    900: '#461d04',
  },
  /**
   * v2's gray, pinned in full.
   *
   * 550 and 750 were the only two the site ever wrote down; 50-900 came from
   * @chakra-ui/theme and are blue-tinted (500 #718096). v3 replaced the ramp
   * with a neutral zinc scale (500 #71717a), and 141 of this theme's 148
   * semantic-token leaves resolve through gray, so inheriting v3's re-tints
   * essentially every neutral surface, divider and line of body text on the
   * site. 550/750 were picked to sit between 500/600 and 700/800 of THIS ramp,
   * which is also why they look out of place against v3's.
   *
   * Read out of /home/snekmin/git/netsnek.com/node_modules/@chakra-ui/theme.
   * v3's gray.950 (#111111) is left alone: v2 had no 950 and nothing here
   * references one.
   */
  gray: {
    50: '#F7FAFC',
    100: '#EDF2F7',
    200: '#E2E8F0',
    300: '#CBD5E0',
    400: '#A0AEC0',
    500: '#718096',
    550: '#5F6C81',
    600: '#4A5568',
    700: '#2D3748',
    750: '#212836',
    800: '#1A202C',
    900: '#171923'
  },
  red: {
    50: '#FFE7E5',
    100: '#FFBBB8',
    200: '#FF908A',
    300: '#FF655C',
    400: '#FF392E',
    500: '#ff0d00',
    600: '#CC0B00',
    700: '#990800',
    800: '#660600',
    900: '#330300'
  },
  blue: {
    50: '#EBECF9',
    100: '#C8C9EF',
    200: '#A4A6E4',
    300: '#8183DA',
    400: '#5d61d0',
    500: '#3A3EC5',
    600: '#2E319E',
    700: '#232576',
    800: '#17194F',
    900: '#0C0C27'
  },
  yellow: {
    50: '#FFF6E5',
    100: '#FFE7B8',
    200: '#FFD78A',
    300: '#FFC75C',
    400: '#FFB72E',
    500: '#FF8A00',
    600: '#CC8600',
    700: '#996500',
    800: '#664300',
    900: '#332200'
  },
  green: {
    50: '#E7EF3',
    100: '#BBFCDE',
    200: '#8FFAC8',
    300: '#63F8B2',
    400: '#37F69D',
    500: '#0CF387',
    550: '#0BDF7D', // middle between 500 & 600 (used for button hover)
    600: '#09C36C',
    700: '#079251',
    800: '#056136',
    900: '#02311B'
  },
  flat: {
    // https://flatuicolors.com/palette/se
    se: {
      vibrantYellow: '#ffd32a',
      green: {
        50: '#E7EF3',
        100: '#BBFCDE',
        200: '#8FFAC8',
        300: '#63F8B2',
        400: '#37F69D',
        500: '#0CF387',
        550: '#0BDF7D', // middle between 500 & 600 (used for button hover)
        600: '#09C36C',
        700: '#079251',
        800: '#056136',
        900: '#02311B'
      }
    },
    // https://flatuicolors.com/palette/nl
    nl: {
      sunflower: '#FFC312'
    }
  }
};

export default themeColors;
